import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "gfu-summary-list-wrapper",
  "data-qa": "skeleton-summary-list"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_line = _resolveComponent("skeleton-line")
  const _component_skeleton_wrapper = _resolveComponent("skeleton-wrapper")

  return (_openBlock(), _createBlock(_component_skeleton_wrapper, { "has-animation": false }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.itemsCount, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item,
            class: "_flex _jc-sb _gap-2"
          }, [
            _createVNode(_component_skeleton_line, {
              height: 20,
              class: "_flex-basis-30 gfu-animation-pulse"
            }),
            _createVNode(_component_skeleton_line, {
              height: 20,
              class: "_flex-basis-10 gfu-animation-pulse"
            })
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }))
}